import { Link } from '@inertiajs/react';
import { Menu, XIcon} from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
    NavigationMenu,
    NavigationMenuItem,
    NavigationMenuList,
    navigationMenuTriggerStyle,
} from '@/components/ui/navigation-menu';
import {
    Sheet,
    SheetContent,
    SheetHeader,
    SheetClose,
    SheetTitle,
    SheetTrigger,
} from '@/components/ui/sheet';
import { useCurrentUrl } from '@/hooks/use-current-url';
import { cn } from '@/lib/utils';
import {
    home,
    contact,
    music,
    concerts,
    about,
    videos
} from '@/routes';

import type { NavItem } from '@/types';

const mainNavItems: NavItem[] = [
    {title: 'Music', href: music()},
    {title: 'Concerts', href: concerts() },
    {title: 'About', href: about() },
    {title: 'Videos', href: videos() },
    {title: 'Booking', href: contact() },
];

const activeItemStyles =
    'text-neutral-900 dark:bg-neutral-800 dark:text-neutral-100';

export default function Header() {
    const { isCurrentUrl, whenCurrentUrl } = useCurrentUrl();
    return (
        <>
            <div className='border-b border-sidebar-border/80 sticky top-0 z-10'>
                <div className="mx-auto flex h-16 items-center px-4 bg-background md:max-w-7xl">
                    <Link
                        href={home()}
                        prefetch
                        className='flex justify-start basis-full text-2xl uppercase items-center'
                    >Eivind Aarset</Link>

                    <div className="lg:hidden">
                        <Sheet>
                            <SheetTrigger asChild>
                                <Button
                                    variant='ghost'
                                    size='icon'
                                    className='mr-2 h-[34px] w-[34px]'
                                >
                                    <Menu className='h-5 w-5'/>
                                </Button>
                            </SheetTrigger>
                            <SheetContent
                                side='none'
                                className='w-full h-full flex-col items-stretch justify-between bg-sidebar'
                            >


                                <SheetTitle className='sr-only'>
                                    Navigation Menu
                                </SheetTitle>
                                <SheetHeader className='flex justify-start text-2xl uppercase items-center'>
                                <Link href={home()}>Eivind Aarset</Link>

                                </SheetHeader>
                                <div className="flex justify-center h-full flex-1 flex-col space-y-8 p-4 items-center">
                                    {mainNavItems.map(item => (
                                        <Link
                                            key={item.title}
                                            href={item.href}
                                            className='flex items-center space-x-2 font-medium text-3xl uppercase'
                                        >
                                            <span>{item.title}</span>
                                        </Link>
                                    ))}
                                </div>

                                <SheetClose className="ring-offset-background focus:ring-ring data-[state=open]:bg-secondary absolute top-5 right-6 rounded-xs opacity-70 transition-opacity hover:opacity-100 focus:ring-2 focus:ring-offset-2 focus:outline-hidden disabled:pointer-events-none">
                                  <XIcon className="size-5" />
                                  <span className="sr-only">Close</span>
                                </SheetClose>

                            </SheetContent>
                        </Sheet>
                    </div>

                    <div className="ml-6 hidden h-full items-center space-x-6 lg:flex">
                        <NavigationMenu className='flex h-full items-stretch'>
                            <NavigationMenuList className='flex h-full items-stretch space-x-2'>
                                {mainNavItems.map((item, index) => (
                                    <NavigationMenuItem
                                        key={index}
                                        className='relative flex h-full items-center'
                                    >
                                        <Link
                                            href={item.href}
                                            className={cn(
                                                navigationMenuTriggerStyle(),
                                                whenCurrentUrl(
                                                    item.href,
                                                    activeItemStyles,
                                                ),
                                                'h-9 cursor-pointer px-3 uppercase',
                                            )}
                                        >
                                            {item.title}
                                        </Link>
                                        {isCurrentUrl(item.href) && (
                                            <div className="absolute bottom-0 left-0 h-0.5 w-full translate-y-px bg-black dark:bg-white"></div>
                                        )}
                                    </NavigationMenuItem>
                                ))}
                            </NavigationMenuList>
                        </NavigationMenu>
                    </div>
                </div>

            </div>
        </>
    )
}
